import { RefObject } from 'preact';
import { useEffect } from 'preact/hooks';
import { teadsApi } from '../../teads-api';

export function useCustomizePlayer(
  adSize: { width: number; height: number },
  videoSlotContainerRef: RefObject<HTMLElement>
) {
  useEffect(() => {
    if (!adSize.width) return;
    const { top: offsetTop = 0 } = videoSlotContainerRef.current?.offsetParent?.getBoundingClientRect() || {};
    const { top = 0, height = 0 } = videoSlotContainerRef.current?.getBoundingClientRect() || {};
    teadsApi.customizeUI(
      () => {},
      `
		    .teads-ui-component-soundbutton.show {
		    	bottom: ${adSize.height - top - height + offsetTop}px;
		    }
		    .teads-ui-component-progressbar * {
		    	display: none !important;
		    }`
    );
  }, [adSize]);
}
